import { useLocalizedNavigate } from '../../hooks/useLocalizedNavigate';
import { useParams } from 'react-router-dom';
import { Autocomplete, Button, CountrySelect } from '../common';
import { useTranslation } from '../../hooks/translations/TranslationProvider';
import { useMemo, useState } from 'react';
import { CountryOptionType, OptionType } from '../../utils/types';
import { useGeoData } from '../../hooks/geoData/useGeoData';

const LandingFilters = () => {
    const { lang } = useParams();
    const navigate = useLocalizedNavigate();
    const locale = lang === 'pl' ? lang : 'en';
    const { t } = useTranslation();

    const {
        isLoading: isGeoDataLoading,
        getCities,
        citiesData,
        error,
    } = useGeoData();
    const [countryCode, setCountryCode] = useState(lang === 'pl' ? 'PL' : 'GB');
    const [city, setCity] = useState('');

    const getCitiesHandler = async (initials: string) => {
        await getCities(countryCode, initials);
    };

    const onCityChange = (_: string, result: OptionType) => {
        setCity(result.label);
    };

    const onCountryChange = (_: string, option: CountryOptionType) => {
        setCity('');
        setCountryCode(option.id);
    };

    const generateOptions = useMemo(() => {
        const citiesOptions: OptionType[] = [];

        citiesData?.forEach(city => {
            citiesOptions.push({
                id: city.id,
                label: city.name,
            });
        });
        return { citiesOptions };
    }, [citiesData]);

    return (
        <form
            className="landing-filters"
            onSubmit={event => {
                event.preventDefault();
                if (city)
                    navigate(
                        `/${locale}/finder?${new URLSearchParams({
                            country: countryCode,
                            city,
                        })}`
                    );
            }}
        >
            {/* <label className="landing-city-label" htmlFor="city">{t('common.cityPlaceholder')}</label> */}
            <div className="landing-filters-inputs">
                <CountrySelect
                    name="countryCode"
                    value={countryCode}
                    onSelect={onCountryChange}
                />
                <Autocomplete
                    name="city"
                    startSearch={getCitiesHandler}
                    isLoading={isGeoDataLoading}
                    error={error}
                    results={generateOptions.citiesOptions}
                    handleOptionClick={onCityChange}
                    placeholder={t('common.cityPlaceholder')}
                    className="landing-filter-input"
                    initialValue={city}
                />
            </div>
            <Button
                type="submit"
                text={t('landing.searchGames')}
                variant="green"
                size="md"
                disabled={!city}
            />
        </form>
    );
};

export default LandingFilters;
